import React, { createContext, useContext, useState, useEffect } from 'react';
// ➡️ Import useApi
import { useApi } from './ApiContext'; 

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    // ➡️ Ambil 'api' (yang ada interceptor) dari context
    const { api } = useApi(); 
    
    const [isAuthenticated, setIsAuthenticated] = useState(null);
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [userType, setUserType] = useState('');
    const [loading, setLoading] = useState(true);

    const userTypeMap = {
        1: 'Customer',
        2: 'Reseller',
        99: 'Admin',
    };

    const checkAuth = async () => {
        try {
            // ➡️ GUNA 'api' BUKAN 'axios'
            // Kerana 'api' ada interceptor 503 yang kita buat tadi
            const res = await api.get('/check-auth'); 

            setIsAuthenticated(res.data.authenticated);
            setUsername(res.data.username || '');
            setEmail(res.data.email || '');

            const typeFromApi = res.data.user_type;
            setUserType(userTypeMap[typeFromApi] || '');
        } catch (err) {
            // Jika error 503, interceptor kita akan handle redirect
            // Jika error lain (401 dll), kita kekal setAuthenticated(false)
            setIsAuthenticated(false);
            setUsername('');
            setEmail('');
            setUserType('');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        checkAuth();
    }, [api]); // Dependency adalah 'api'

    return (
        <AuthContext.Provider
            value={{
                isAuthenticated,
                username,
                email,
                userType,
                loading,
                setIsAuthenticated,
                setUsername,
                setEmail,
                checkAuth,
            }}
        >
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);